import { put } from "redux-saga/effects";

import { readFromLocalStorage } from "common/utilities/localStorage";
import { logger } from "common/utilities/logger";
import { fetchUsedCoachmarksSuccess } from "domains/coachmarks/actions";

export function* fetchUsedCoachmarksSaga() {
  let usedCoachmarks: string[] = [];
  try {
    const value = readFromLocalStorage("COACHMARKS_VIEWED_ITEMS");
    if (value !== undefined) usedCoachmarks = value;
  } catch (error) {
    logger.error("[fetchUsedCoachmarksSaga] Error occurred while fetching used coachmarks", error);
  }

  yield put(fetchUsedCoachmarksSuccess({ ids: usedCoachmarks }));
}
